import emotionStyled from '@emotion/styled';

import type theme from './theme-config';

type PortalTheme = typeof theme;

declare module '@emotion/react' {
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    export interface Theme extends PortalTheme {}
}

const styled = emotionStyled;

export default styled;
